import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-links">
        <Link to="/menu">Menú</Link>
        <Link to="/takeaway">Delivery</Link>
        <Link to="/contactus">Contáctenos</Link>
      </div>
    </nav>
  );
}

export default Navbar;